<template>
  <bg-style class="store-widget-v2__two-column-list-item" :radius="model.goodsRadius" :bg="model.goodsBackground" @click.native="handleClick">
    <im-image v-if="isHasCorner" :src="good.corner" class="corner-logo" />
    <bg-style class="thumb relative" :radius="[model.goodsRadius, model.goodsRadius, 0, 0]" :bg="{...good.thumbBg, backgroundSize: model.iconFillType}">
      <img v-if="model.activityFlag.backgroundImageShow && hasGift" class="activity-flag" :src="model.activityFlag.backgroundImage" alt="">
    </bg-style>
    <div class="name relative">{{ good.names.name }}</div>
    <div class="desc relative" :title="good.names.desc">{{ good.names.desc }}</div>
    <div v-if="isShowOriginalPrice || good.is_purchase_limit" class="flex justify-between info items-center relative">
      <span class="original-price">
        <i v-if="isShowOriginalPrice" class="not-italic">{{ originalPriceText }}</i>
      </span>
      <span v-if="good.is_purchase_limit" class="limit">Limit {{ good.has_purchase_num }}/{{ good.limit_purchase_num }}</span>
    </div>
    <div v-if="stopCountdownTimer" class="mt-2 stop-countdown relative">
      {{ $t('siteBuild.stopCountdown') }}：<span>{{ stopCountdownDays }}d:{{ stopCountdownHours }}:{{ stopCountdownMinutes }}:{{ stopCountdownSeconds }}</span>
    </div>
    <div v-if="hasGift" class="gifts flex items-center relative">
      <span class="mr-2 flex-shrink-0">Gifts：</span>
      <div class="flex items-center hide-scroll overflow-auto w-full">
        <div v-for="(item, index) in good.gift_list" :key="index + 'gift'" class="gift-item ml-1 first-of-type:ml-0 mr-1 flex items-center flex-shrink-0">
          <img class="w-[16px] h-[16px]" alt="" :src="item.gift_goods_logo">
          <i class="el-icon-close mx-1" />
          <span>{{ item.num }}</span>
        </div>
      </div>
    </div>
    <div v-if="isShowCountdown" class="pre-btn flex items-center justify-center relative">
      <i class="el-icon-time text-14 mr-2" />
      <span>{{ countdownDays }}d:{{ countdownHours }}h:{{ countdownMinutes }}m:{{ countdownSeconds }}s</span>
    </div>
    <div v-else class="pay-btn relative">
      <shop-cart v-if="hasShopCart" class="shop-cart" :class="{'sold-out': isSaleOut}" :site="site" :model="model" :good="good" :disabled="editing" />
      <div v-if="isSaleOut" :class="{ 'no-shop-cart': !hasShopCart }" class="sold-out price-block" @click.stop>
        SOLD OUT
      </div>
      <div v-else class="price-block" :class="{ 'no-shop-cart': !hasShopCart }" @click.stop="handleSubmit">{{ realPriceText }}</div>
    </div>
  </bg-style>
</template>

<script>
import cloneDeep from "lodash.clonedeep";
import ShopCart from '../shopCart.vue'
import goodMixins from "~/site/widgets/storeWidget/oneGood/goodMixins";
export default {
  name: 'StoreWidgetV2TwoColumnListItem',
  components: {
    ShopCart
  },
  mixins: [goodMixins],
  props: {
    editing: {
      type: Boolean,
      default: false
    },
    site: {
      type: Object,
      default() {
        return {}
      }
    },
    model: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {}
  },
  created() {
    //
  },
  methods: {
    handleClick() {
      if (this.editing || this.isSaleOut) return
      this.$emit('click', this.good)
    },
    handleSubmit() {
      this.$emit('submit', cloneDeep(this.good))
    }
  }
}
</script>

<style lang="less">
.store-widget-v2__two-column-list-item {
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  height: fit-content;
  border-radius: var(--goods-border-radius);
  .color-bg {
    border-radius: var(--goods-border-radius);
  }
  .thumb {
    height: 122px;
    border-radius: var(--goods-border-radius) var(--goods-border-radius) 0 0;
    .activity-flag {
      position: absolute;
      height: 30px;
      bottom: -16px;
      right: -2px;
    }
  }
  .corner-logo {
    position: absolute;
    left: -3px;
    top: -3px;
    width: 62px;
    height: 62px;
    z-index: 10;
  }
  .name {
    font-size: 12px;
    font-weight: bold;
    margin-top: 8px;
    padding: 0 10px;
    color: var(--main-text-color);
    word-break: break-word;
  }
  .desc {
    font-size: 10px;
    margin-top: 4px;
    padding: 0 10px;
    word-break: break-all;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    color: var(--second-text-color);
  }
  .info {
    margin-top: 8px;
    padding: 0 10px;
    .original-price {
      font-size: 10px;
      text-decoration: line-through;
      color: var(--second-text-color);
    }
    .limit {
      font-size: 10px;
      color: var(--main-text-color);
      border: 1px solid var(--main-text-color);
      padding: 0 4px;
      border-radius: var(--goods-border-radius);
    }
  }
  .stop-countdown {
    color: var(--main-text-color);
    font-size: 10px;
    padding: 0 10px;
  }
  .gifts {
    font-size: 10px;
    padding: 0 10px;
    margin-top: 10px;
    color: var(--second-text-color);
    .hide-scroll {
      &::-webkit-scrollbar {
        display: none;
      }
    }
    .item {
      img {
        width: 14px;
        height: 14px;
      }
    }
  }
  .pre-btn {
    line-height: 32px;
    margin: 10px;
    background: rgba(0, 0, 0, 0.3);
    color: white;
    font-size: 10px;
    border-radius: var(--goods-border-radius);
  }
  .pay-btn {
    padding: 0 10px;
    margin: 10px 0;
    display: flex;
    .shop-cart {
      width: 32px;
      height: 32px;
      background: var(--button-bg-color);
      display: flex;
      align-items: center;
      justify-content: center;
      color: var(--button-text-color);
      font-size: 18px;
      border-radius: var(--goods-border-radius) 0 0 var(--goods-border-radius);
      flex-shrink: 0;
      margin-right: 5px;
      &.sold-out {
        opacity: 0.6;
        cursor: not-allowed;
        pointer-events: none;
      }
    }
    .price-block {
      background: var(--button-bg-color);
      width: 100%;
      line-height: 32px;
      text-align: center;
      border-radius: 0 var(--goods-border-radius) var(--goods-border-radius) 0;
      color: var(--button-text-color);
      font-size: 12px;
      &.no-shop-cart {
        border-radius: var(--goods-border-radius);
      }
      &.sold-out {
        opacity: 0.6;
        cursor: not-allowed;
        pointer-events: none;
      }
    }
  }
}
</style>
